<template>
  <div class="devicebelonglist">
    <div class="section">
      <div class="tablemain tableloding">
        <!-- @selection-change="changeFun" -->
        <!-- height="100%" -->
        <el-table :data="deviceList" border stripe :row-style="{height:0}" :cell-style="{padding:0}"
          :header-cell-style="{background:'rgb(65, 80, 90)',color:'#ffffff'}" v-loading="loadingdevice"
          element-loading-spinner="el-icon-loading">
          <!-- :empty-text="$t('message.nodata')" -->
          <!-- <el-table-column fixed type="selection"></el-table-column> -->
          <el-table-column :show-overflow-tooltip="true" fixed min-width="110px;" :label="$t('device.device_name')"
            style="position:relative;">
            <template slot-scope="scope">
              <span class="redirect" @click="enterGeneralDevice(scope.row)" :title="scope.row.devalias || scope.row.sn">{{
                scope.row.devalias || scope.row.sn }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px;" :show-overflow-tooltip="true" :label="$t('device.device_sn')">
            <template slot-scope="scope">
              <span :title="scope.row.deviceSn||scope.row.sn || '--'">{{ scope.row.deviceSn || scope.row.sn || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" min-width="120px;" :show-overflow-tooltip="true"
            :label="$t('device.device_status')">
            <template slot-scope="scope">
              <div :class="`background-${$filter.deviceStatus[scope.row.status].name}`" style="border-radius: 5px;">
                <span :class="`radius-${$filter.deviceStatus[scope.row.status].name}`" style="width: 8px;height: 8px;border-radius: 8px;display: inline-block;margin-right: 5px;"></span>
                <span v-if="scope.row.status !== undefined" :class="`color-${$filter.deviceStatus[scope.row.status].name}`">{{
                $filter.deviceStatus[scope.row.status].label||"--" }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="devaddr" min-width="130px;" :show-overflow-tooltip="true"
            :label="$t('device.device_address')"></el-table-column>
          <el-table-column min-width="115px;" :show-overflow-tooltip="true" :label="$t('device.device_type')">
            <template slot-scope="scope">
              <span v-if="scope.row.brand>=0&&scope.row.brand<=4" :title="$filter.deviceType[scope.row.brand].label">{{ $filter.deviceType[scope.row.brand].label }}</span>
              <span v-else :title="'--'">{{ '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="devcode" min-width="90px;" :show-overflow-tooltip="true"
            :label="$t('device.device_code')"></el-table-column>
          <el-table-column min-width="120px;" :show-overflow-tooltip="true" :label="$t('device.User_belong')">
            <template slot-scope="scope">
              <span class="redirect"  @click="enterGeneralDevice(scope.row)" :title="scope.row.usr || '--'">{{ scope.row.usr || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="this.$t('device.Operation')" width="240px" class="fixedRgiht">
            <template slot-scope="scope">
              <el-button type="text" class="operation" :title="$t('device.edit')" @click="editDevice(scope.row)">
                <i class="iconfont icon-bianji"></i>
              </el-button>
              <el-button type="text" class="operation" :title="$t('device.debug')" @click="debugDevice(scope.row)">
                <i class="iconfont icon-tiaoshi1"></i>
              </el-button>
              <el-button type="text" class="operation" :title="$t('device.control')" @click="controlDevice(scope.row)">
                <i class="iconfont icon-caozuo_kongzhi"></i>
              </el-button>
              <el-button type="text" class="operation" :title="$t('device.upgrade1')" @click="upgradeDevice(scope.row)">
                <i class="iconfont icon-caozuo_shengji"></i>
              </el-button>
              <el-button type="text" class="operation" :title="$t('report.Export_report')"
                @click="exportPlant([scope.row])">
                <i class="iconfont icon-baobiao"></i>
              </el-button>
            </template>
          </el-table-column>
          <!-- 暂无数据 -->
          <div v-show="emptyText" slot="empty">
            <!-- <img src="@/assets/img/empty_text.png" /> -->
            <div style="line-height: 32px">{{ $t('account.nodata') }}</div>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <!-- v-show="paginationControl" -->
        <el-pagination v-show="paginationControl" class="pagination" background @size-change="getDeviceList(true)"
          @current-change="()=>getDeviceList()" :current-page.sync="pagination.currentPage" :page-sizes="[10,15,20,30,50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next" :total="pagination.total"
          popper-class="select-page-recharge">
          <span style="color:#ffffff;padding-left:15px;">{{$t('device.pageSize')}} :</span>
        </el-pagination>
      </div>
      <!-- 导出报表 -->
      <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>

      <!-- 编辑设备 -->
      <!-- v-if="editDeviceVisible" -->
      <device-dialog :title="$t('device.modify_alias')" :visible.sync="editDeviceVisible"
        :class="{ 'showDialog': editDeviceVisible, 'hideDialog': !editDeviceVisible }" noFooter>
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
              <el-input :value="formEdit.deviceSn || formEdit.sn" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
              <el-input v-model="formEdit.devalias" clearable></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align:right;">
            <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
          </div>
        </div>
        <div slot="footer">
        </div>
      </device-dialog>
      <!-- 修改设备结果提示(成功) -->
      <!-- v-if="editDeviceSucVisible" -->
      <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible"
        :class="{ 'showDialog': editDeviceSucVisible, 'hideDialog': !editDeviceSucVisible }" width="500px" noFooter>
        <div slot="content">
          <div class="showresultbox">
            <span class="showbase showsuccess"></span>
            <span class="showresulttext">{{ $t('project.editSuc') }}</span>
            <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
            <!-- 确定 -->
            <div class="showoperate">
              <button class="btn btn-dark" @click="editDeviceSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
            </div>
          </div>
        </div>
      </device-dialog>
      <!-- 修改设备结果提示(失败) -->
      <!-- v-if="editDeviceFailVisible" -->
      <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible"
        :class="{ 'showDialog': editDeviceFailVisible, 'hideDialog': !editDeviceFailVisible }" width="500px" noFooter>
        <div slot="content">
          <div class="showresultbox">
            <span class="showbase showfail"></span>
            <span class="showresulttext">{{ deviceTipMsg }}</span>
            <!-- 确定 -->
            <div class="showoperate">
              <button class="btn btn-dark" @click="editDeviceFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
            </div>
          </div>
        </div>
      </device-dialog>
      <!-- 逆变器调试 -->
      <!-- v-if="debugDeviceVisible" -->
      <device-dialog :title="$t('device.debug')" :visible.sync="debugDeviceVisible"
        :class="{ 'showDialog': debugDeviceVisible, 'hideDialog': !debugDeviceVisible }" noFooter>
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('device.Device_pn')" size="small">
              <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.Instruction')" size="small">
              <el-input v-model="devDebug.cmd" :placeholder="$t('device.such_as')" type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }" auto-complete="off"></el-input>
            </el-form-item>
            <!-- 发送指令 -->
            <el-form-item label=" ">
              <div style="text-align:right;">
                <button class="btn btn-dark" type="button" @click="submitDebugDevice()">{{ $t('device.send') }}</button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('device.return_content')" size="small">
            <!-- <el-input 
                readonly 
                v-model="debugReturn" 
                type="textarea" 
                auto-complete="off"
                          ></el-input> -->
              <div class="debug-return">
                <!-- id="link" -->
                <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
                <div class="return-tool">
                  <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                    data-clipboard-target="#link"><i class="ico ico-copy"></i>{{ $t('device.copy_val') }}
                  </span>
                  <span class="btn" @click="qingkong()"><i class="ico ico-clear"></i>{{ $t('device.clear_val') }}
                  </span>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
        <!-- <button 
            class="button-hollow" 
            @click="qingkong()"
                      >{{$t('device.clear_data')}}</button> -->
        <!-- <button
            class="button-solid"
            type="primary"
            @click="submitDebugDevice()"
                      >{{$t('device.send')}}</button> -->
        </div>
      </device-dialog>
      <!-- 控制项 -->
      <!-- v-if="controlDeviceVisible" -->
      <device-dialog :title="$t('device.control')" :width="'1000px'" style="padding: 0 35px 36px;"
        :visible.sync="controlDeviceVisible"
        :class="{ 'showDialog': controlDeviceVisible, 'hideDialog': !controlDeviceVisible }" noFooter>
        <div @click="clickClosePicker()" class="control" slot="content">
          <div v-if="tableDataBse.length">
            <div class="tableTitle">{{ $t('createPlant.basic_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBse" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataStd.length">
            <div class="tableTitle">{{ $t('createPlant.Standard_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataStd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataSvs.length">
            <div class="tableTitle">{{ $t('createPlant.System_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataPvs.length">
            <div class="tableTitle">{{ $t('createPlant.Solar_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="background-color: #fff;">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataGrd.length">
            <div class="tableTitle">{{ $t('createPlant.Grid_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="padding: 0;">
                <template slot-scope="scope">
                  <div style="padding: 0;" class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataBat.length">
            <div class="tableTitle">{{ $t('createPlant.Battery_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBat" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataCts.length">
            <div class="tableTitle">{{ $t('createPlant.Control_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataCts" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataLos.length">
            <div class="tableTitle">{{ $t('createPlant.Load_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataLos" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataBas.length">
            <div class="tableTitle">{{ $t('createPlant.Basic_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBas" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataAdv.length">
            <div class="tableTitle">{{ $t('createPlant.Advanced_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataElse.length">
            <div class="tableTitle">{{ $t('createPlant.other_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataElse" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                      type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 无数据 -->
          <div v-if="noDataControl">
            <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
              <el-table-column :label="$t('device.Field_Name')"></el-table-column>
              <el-table-column :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
            </el-table>
          </div>
        </div>
      </device-dialog>
      <!-- 固件升级 -->
      <!-- v-if="upgradeDeviceVisible" -->
      <device-dialog :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible"
        :class="{ 'showDialog': upgradeDeviceVisible, 'hideDialog': !upgradeDeviceVisible }" width="580px" noFooter>
        <div slot="content">
          <el-form class="grid upload-container upgradeNew"   element-loading-spinner="el-icon-loading" v-loading="loadingupgradeDev">
            <el-form-item :label="$t('device.select_firmware')" size="small">
              <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
                :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                <template slot="empty">
                  <div style="text-align:right;">
                    <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware')
                    }}</button>
                  </div>
                </template>
                <div style="text-align:right;">
                  <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button>
                </div>
                <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.firmware_type')" size="small">
              <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
                popper-class="select-search-recharge">
                <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
              <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
                popper-class="select-search-recharge" ref="autoSelected">
                <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.upgrade_brate')" size="small">
              <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
                popper-class="select-search-recharge">
                <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="progressShowEquipment">
                  <div class="processstatueEquipment" v-show="progressUp">{{ $t('firmware.upgrading') }}</div>
                  <div :class="progressFlag==0?'processstatueEquipment':'processstatueEquipment1'" v-show="progerssComplete">{{resultTitle}}</div>
                  <!-- <div class="progressName">
                    <i class="iconfont icon-fujian"></i>
                    {{ firmwareName }}
                  </div>
                  <div class="progressCancel" @click="upgradeCancel">
                    <i class="iconfont icon-delete"></i>
                  </div> -->
                </div>
                <div class="processDataEquipment" v-show="progressUp">
                  <el-progress :format="progressText" :percentage="progress" :stroke-width="10" color="#33FFB6"></el-progress>
                  <!-- <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div> -->
                </div>
            </el-form-item>
          </el-form>
          <div style="text-align:right;">
            <button style="margin-right: 20px;"  v-show="progressUp" class="btn btn-dark"  @click="upgradeCancel">{{ $t('firmware.upgrade_quit6') }}</button>
            <el-button class="elbtn btn-dark" :disabled="upgradebButtonStatus"  @click="submitUpgradeDevice">{{ $t('device.confirm') }}</el-button>
          </div>
        </div>
        <div slot="footer">
          <!-- <button
            class="button-hollow"
            @click="upgradeDeviceVisible = false"
          >{{$t('device.cancel')}}</button>-->
          <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
        </div>
      </device-dialog>
      <!-- 固件升级二次弹窗（增加固件的对话框） -->
      <!-- style="z-index:2014!important;" -->
      <!-- v-if="dialogAdd" -->
      <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
      <updateDialog :title="$t('firmware.Upload_firmware')" :visible.sync="dialogAdd" v-if="dialogAdd" width="40vw"
        noFooter style="z-index:3000;">
        <div slot="content">
          <el-form class="grid upload-container">
            <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
            <el-form-item :label="$t('firmware.Firmware_description')" size="small">
              <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
            </el-form-item>
            <el-form-item label=" ">
              <div class="upload-contents">
                <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan1"></i>
                  <!-- {{$t('datalogger.Upload')}} -->
                </button>
                <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
                <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                  @change="uploadfile($event)" />
              </div>
            </el-form-item>
          </el-form>
          <div style="text-align:right;">
            <button class="btn btn-dark" @click="dialogAdd = false">{{ $t('datalogger.confirm') }}</button>
            <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
          </div>
        </div>
        <div slot="footer">
          <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
          <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </updateDialog>
      <!-- 升级结果提示(成功) -->
      <!-- v-if="upgradeDeviceSucVisible" -->
      <device-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceSucVisible"
        :class="{ 'showDialog': upgradeDeviceSucVisible, 'hideDialog': !upgradeDeviceSucVisible }" width="500px"
        noFooter>
        <div slot="content">
          <div class="showresultbox">
            <span class="showbase showsuccess"></span>
            <span class="showresulttext">{{ $t('project.upgradeSuc') }}</span>
            <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
            <!-- 确定 -->
            <div class="showoperate">
              <button class="btn btn-dark" @click="upgradeDeviceSucVisible = false;">{{ $t('datalogger.confirm')
              }}</button>
            </div>
          </div>
        </div>
      </device-dialog>
      <!-- 升级结果提示(失败) -->
      <!-- v-if="upgradeDeviceFailVisible" -->
      <device-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceFailVisible"
        :class="{ 'showDialog': upgradeDeviceFailVisible, 'hideDialog': !upgradeDeviceFailVisible }" width="500px"
        noFooter>
        <div slot="content">
          <div class="showresultbox">
            <span class="showbase showfail"></span>
            <span class="showresulttext">{{ deviceTipMsg }}</span>
            <!-- 确定 -->
            <div class="showoperate">
              <button class="btn btn-dark" @click="upgradeDeviceFailVisible = false;">{{ $t('datalogger.confirm')
              }}</button>
            </div>
          </div>
        </div>
      </device-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex';
import exportPlantDialog from "@/components/dialognew/exportPlant";
import deviceDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
import clipboard from "@/assets/js/clipboard";
export default {
  components: {
    deviceDialog,
    updateDialog,
    exportPlantDialog
  },
  data() {
    return {
      upgradebButtonStatus:false,
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      loadingupgradeDev:false,
      noDataControl: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        brand: "",
        pn: "",
        search: ""
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelistUPG: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "1"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "2"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "3"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "4"
        }
      ],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id:11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id:12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id:13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id:14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id:15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id:16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      }, //分页数据
      deviceList: [],
      //操作新增字段
      // 导出报表
      exportPlantParams: [],
      // 导出报表按钮
      currentData: true,
      // 编辑弹窗
      editDeviceVisible: false,
      formEdit: {
        sn: "",
        deviceSn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        alias: ""
      },
      // 修改设备成功提示
      editDeviceSucVisible: false,
      // 修改设备失败提示
      editDeviceFailVisible: false,
      // 操作返回提示
      deviceTipMsg: "",
      debugDeviceVisible: false,
      device: {
        pn: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      controlDeviceVisible: false,
      // 升级设备成功
      upgradeDeviceSucVisible: false,
      // 升级设备失败
      upgradeDeviceFailVisible: false,
      tableDataBse: [],
      tableDataStd: [],
      tableDataSvs: [],
      tableDataPvs: [],
      tableDataGrd: [],
      tableDataBat: [],
      tableDataCts: [],
      tableDataLos: [],
      tableDataBas: [],
      tableDataAdv: [],
      tableDataElse: [],
      tableDataHuangJinTai: [], //黄金台定制
      controlinter: [],
      controlvalue: "",
      upgradeDeviceVisible: false,
      hideFlag: false,//德业域名显隐
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      flag:false,
      resultTitle:"",
      progressFlag:Number,
    };
  },
  watch: {
    // 监听控制项弹框，触发其中的日期时间选择器弹框关闭
    controlDeviceVisible (val) {
      if (!val) {
        this.clickClosePicker()
      }
    },
    upgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    deviceInfo(){
      this.getDeviceList();
    },
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo',
      upgradeUPG: "getUpgradeUPG",
      UpgradeTypeUPG: "getUpgradeTypeUPG",
    }),
             ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  beforeDestroy() {
    clearInterval(this.interval); // 在组件销毁之前清除定时器
  },
  created() {
    this.showHides();
    this.getDeviceList();
  },
  methods: {
    //德业域名
    showHides () {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true
      }
    },
    //取消升级
    upgradeCancel () {
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
          pn: this.dataparams.pn,
          key: this.keyProgress
        }
        this.$request.putUPG(`/upg/api/auth/web/device/upgradeCancel`,parmas).then(res=>{
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        })
      }else{
        this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
      }
    },
    // 导出报表
    exportPlant (exportPlantParams) {
      if(this.disPermissionsLogo&&!this.btnList.includes('export_report')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    // 编辑设备
    editDevice (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('edit_devcie')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.editDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 确定修改设备名称
    submitEditDevice () {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias
      };
      this.$request.get("editDeviceInfo", param).then(res => {
        if (res.err == 0) {
          this.formEdit = {};
          this.editDeviceVisible = false;
          this.editDeviceSucVisible = true;
          this.getDeviceList();
        } else {
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.editDeviceFailVisible = true;
        }
      });
    },
    // 调试设备
    debugDevice (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('debug_device')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.debugDeviceVisible = true;
      this.$request
        .get("queryDeviceInfo", {
          device:
            info.pn + "," + info.devcode + "," + info.devaddr + "," + info.sn
        })
        .then(res => {
          if (res.err === 0) {
            this.device = res.dat[0];
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDevice () {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.device.pn,
          devaddr: this.device.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 跳转所属用户或设备
    enterGeneralDevice (info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 控制项日期时间选择窗口关闭处理
    clickClosePicker(){
      if (this.$refs['controlDatepickerRef-system_time']) {
        this.$refs['controlDatepickerRef-system_time'].hidePicker()
      }
      if (this.$refs['controlDatepickerRef-sys_system_time']) {
        this.$refs['controlDatepickerRef-sys_system_time'].hidePicker()
      }
    },
    // 控制项操作处理
    OperationStyle({row,column,rowIndex,columnIndex}){
      if (columnIndex==3) {
        return "background:#222d35;"
      }
    },
    // 控制项
    controlDevice (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('control_device')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
     i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then(res => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [],
            arr6 = [],
            arr7 = [],
            arr8 = [],
            arr9 = [],
            arr10 = [],
            arr11 = []

          tableData.forEach(field => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach(item => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                field.controlinter.push({
                  label: item.val,
                  value: item.key
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field);
            } else if (s.startsWith("std_")) {
              arr2.push(field);
            } else if (s.startsWith("sys_")) {
              arr3.push(field);
            } else if (s.startsWith("pvs_")) {
              arr4.push(field);
            } else if (s.startsWith("grd_")) {
              arr5.push(field);
            } else if (s.startsWith("bat_")) {
              arr6.push(field);
            } else if (s.startsWith("cts_")) {
              arr7.push(field);
            } else if (s.startsWith("los_")) {
              arr8.push(field);
            } else if (s.startsWith("bas_")) {
              arr10.push(field);
            } else if (s.startsWith("adv_")) {
              arr11.push(field);
            } else {
              arr9.push(field);
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        } else {
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
      //黄金台设备调用下方黄金台定制funtcion
      if (info.devcode == 2384) {
        this.getHuangjintaiControl(info);
      } else if (info.devcode == 2366) {
        this.getHuangjintaiControl(info);
      } else {
        this.tableDataHuangJinTai = [];
      }
    },
    //黄金台定制,获取电池电压和倍率
    getHuangjintaiControl (info) {
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr
      };
      this.$request.get("queryCtrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: res.dat.voltage,
            multiply: res.dat.multiply
          });
        } else if (res.err == 8) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: 12,
            multiply: 0.09
          });
        } else {
          this.tableDataHuangJinTai = [];
        }
      });
    },
    huangjintaiChange (val) {
      var volArr = [
        { key: "12V", val: 12 },
        { key: "24V", val: 24 },
        { key: "48V", val: 48 },
        { key: "96V", val: 96 }
      ];
      var mulArr = [
        { key: "0.09", val: 0.09 },
        { key: "0.18", val: 0.18 },
        { key: "0.36", val: 0.36 },
        { key: "0.72", val: 0.72 }
      ];
      volArr.forEach((element, index) => {
        if (element.val == val) {
          this.tableDataHuangJinTai[0].multiply = mulArr[index].val;
        }
      });
    },
    // 控制项获取当前值
    huoquInverter (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        id: info.id,
        i18n: this.$lang.currentLang
      };
      this.$set(info, "isLoading", true);
      // info.isLoading = true;
      this.$request.get("queryDeviceCtrlValue", param).then(res => {
        if (res.err == 0) {
          if (res.dat.val == "undefined" || res.dat.val == "null") {
            res.dat.val = "--";
          }
          // if(info.controlinter.length){
          //   this.$set(info, 'controlvalue', res.dat.key||res.dat.val)
          // }else{
          //   this.$set(info, 'controlvalue', res.dat.val)
          // }
          if(info.controlinter.length){
            info.controlinter.forEach((item) => {
              //  此处处理用的label和接口返回的val匹配忽略大小写
                if (item.label == res.dat.val) {
                  this.$set(info, 'controlvalue', item.value)
                }else if(item.label.toString().toLowerCase() == res.dat.val.toString().toLowerCase()){
                  this.$set(info, 'controlvalue', item.value)
                }
            });
            if(!info.controlvalue)
            this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
          }else{
            this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.isLoading = false;
        this.$set(info, "isLoading", false);
      }).catch(() => {
          this.$set(info, "isLoading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
    },
    // 下发指令(黄金台)
    xiafaInverterHuangJinTai (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        voltage: info.voltage,
        multiply: info.multiply
      };
      // info.Loading = true;
      this.$set(info, "Loading", true);
      this.$request.get("ctrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.Send_suc"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.Loading = false;
        this.$set(info, "Loading", false);
      });
    },
    // 下发指令
    xiafaInverter (info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang
        };
        this.$set(info, "Loading", true);
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then(res => {
          // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
          } else {
            if (this.controlparams.devcode == 2376) {
              if (res.desc.match(/\(([^)]*)\)/)) {
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              } else {
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info, "Loading", false);
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr (item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 设备固件升级
    upgradeDevice (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('upgrade_device')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      Object.assign(this.$data.firmwaretypelist,this.$options.data.call(this).firmwaretypelist)
      Object.assign(this.$data.firmwaretypelist1,this.$options.data.call(this).firmwaretypelist1)
      this.searchrecharge.firmwaretype = "0"
      this.searchrecharge.brate = "0"
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType/${info.devcode}`).then(res=>{
        if(res.code == 0){
         if(res.data.items && res.data.items.length != 0){
          this.$store.commit('saveUpgradeUPG', true);
          res.data.items.map(item => {
        item.value = item.id;
        item.label = item.typeName;
      });
          this.firmwaretypelist = res.data.items
          this.searchrecharge.firmwaretype =  res.data.items[0].id
          this.queryFirmware();
          this.queryDeviceUpgradeStatus(info)
         }else{
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=>{
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom()
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
             }else{
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
             this.queryFirmware();
            this.queryDeviceUpgradeStatus(info)
           })
         }
        }else{
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=>{
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom()
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
              }
             }else{
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
             this.queryFirmware();
             this.queryDeviceUpgradeStatus(info)
           })
        }
      }).catch(() => {
        this.$store.commit('saveUpgradeTypeUPG', false);
        this.queryFirmware();
        this.queryDeviceUpgradeStatus(info)
      })

      this.upgradeDeviceVisible = true;
      this.dataparams = info;
      this.progerssComplete = false;
    },
    getUpgFirmwaretypeNom() {
        this.$request.getUPG(`/upg/api/auth/web/device/upgradeType`).then(res=>{
        if(res.code == 0){
          if(res.data.items && res.data.items.length != 0){
            var arrList =[]
            res.data.items.forEach((element,index) => {
              arrList.push({
                value:element.id,
                label:element.typeName,
                id:index,
              })
           })
            this.firmwaretypelist=arrList
            this.searchrecharge.firmwaretype =  this.firmwaretypelist[0].value
          }
        }
       });
     },
    // 查询设备升级状态
    queryDeviceUpgradeStatus(info){
      let params = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeStatus", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                this.keyProgress = res.data.key;
                this.upgradebButtonStatus = true;
                this.queryProgress();
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
              }
            }
          });
      }else{
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeStatus",params).then(res=>{
        if (res.code==0) {
          if (res.data.status==0) {
            this.keyProgress=res.data.key
            this.upgradebButtonStatus = true;
            this.queryProgress()
          }
        }
      })
     }
    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
          page: 1,
          pageSize: 50
        };
        this.loadingupgradeDev = true
        // 接入UPG升级
        this.$request
          .getUPG("/upg/api/auth/web/device/firmwares", parmas)
          .then(res => {
            if (res.code == 0) {
              res.data.items.forEach(item => {
               this.rechargelist.push({
              id: item.id,
              firmware: item.firmwareName,
              size: item.fileSize
            });
          });
            }
            this.loadingupgradeDev = false
          });
        }else{
          this.loadingupgradeDev = true
          this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
            if (res.code == 0) {
              res.data.items.forEach(item => {
                this.rechargelist.push({
                  id: item.id,
                  firmware: item.firmware,
                  size: item.size
                });
              });
            }
            this.loadingupgradeDev = false
          });
        }
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
        firmwareName:file.name,
        versionNote:'V1.0',
        deleteFlag:'0',
        upgradeMode:1,
        note:this.desc,
      }
      this.$request.uploadFirmware('/upg/api/auth/web/device/firmware',file, parmas).then(res => {
        // 关闭二次弹窗
        this.dialogAdd = false;
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
        } else {
          this.$message.error(res.message);
        }
        this.queryFirmware();
      });
      }else{
      this.$request.uploadfileAxios(file, this.desc).then(res => {
        // 关闭二次弹窗
        this.dialogAdd = false;
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
        }
        this.queryFirmware();
      });
     }
    },
    // 确认固件升级
    submitUpgradeDevice () {
      this.resultTitle=""
      this.flag = true;
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        this.upgradebButtonStatus = true;
        if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
          let UPGparams = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
          // 接入UPG升级
          this.$request
            .postUPG("/upg/api/auth/web/device/upgradeTransmission", UPGparams)
            .then(res => {
              if (res.code == 0) {
            if (res.data.status == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              this.queryProgress();
            } else if (res.data.status == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              this.upgradebButtonStatus = false;
            } else if (res.data.status == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              this.upgradebButtonStatus = false;
            } else if (res.data.status == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              this.upgradebButtonStatus = false;
            }
          } else {
            this.$message.error(res.message);
            this.upgradebButtonStatus = false;
          }
            });
        }else{
        let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              this.queryProgress();
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              this.upgradebButtonStatus = false;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              this.upgradebButtonStatus = false;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              this.upgradebButtonStatus = false;
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            this.upgradebButtonStatus = false;
          }
        });
       }
      }
    },
    // 查询升级进度(增加批量标志)
    queryProgress (info, curIndex) {
      this.progressUp = true;
      this.progerssComplete = false;
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let params = {
        pn: this.dataparams.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeProgressByKey", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  this.progressFlag=res.data.status
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.progressSuc();
                  this.resultTitle=this.$t("firmware.updateCompleted")
                  return;
                }
              }  else if (res.data.status == 1) {
                // =》'升级异常，已退出'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit1")
                return;
              } else if (res.data.status == 2) {
                // =》'升级失败,请稍后再试'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit2")
                return;
              } else if (res.data.status == 3) {
                // =》'升级成功'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit3")
                return;
              } else if (res.data.status == 4) {
                // =》'升级被手动取消'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit4")
                return;
              } else if (res.data.status == 5) {
                // =》'未在升级中'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit5")
                return;
              }
            }else {
              this.progressUp = false;
              this.progerssComplete = true;
              this.resultTitle=this.$t(`errCode.${res.err}`)
              clearInterval(this.interval);
              this.interval = null;
              this.upgradebButtonStatus = false;
            }
          });
      }, 2000);

      }else{
      let params = {
        // 查设备升级进度所需参数
        pn: info ? info.pn : this.dataparams.pn,
        devaddr: info ? info.devaddr : this.dataparams.devaddr,
        devcode: info ? info.devcode : this.dataparams.devcode,
        sn: info ? info.sn : this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress = this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  this.progressFlag=res.data.status
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.progressSuc();
                  this.resultTitle=this.$t("firmware.updateCompleted")
                  return;
                }
              } else if (res.data.status == 1) {
                // =》'升级异常，已退出'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit1")
                return;
              } else if (res.data.status == 2) {
                // =》'升级失败,请稍后再试'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit2")
                return;
              } else if (res.data.status == 3) {
                // =》'升级成功'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit3")
                return;
              } else if (res.data.status == 4) {
                // =》'升级被手动取消'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit4")
                return;
              } else if (res.data.status == 5) {
                // =》'未在升级中'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit5")
                return;
              }
            }else {
              this.progressUp = false;
              this.progerssComplete = true;
              // this.resultTitle=this.$t(`errCode.${res.code}`)
              this.resultTitle=res.message
              clearInterval(this.interval);
              this.interval = null;
              this.upgradebButtonStatus = false;
            }
          });
      }, 2000);
     }
    },
    progressSuc(){
      if (this.flag) {
      this.$message.success(this.$t("device.Update_Completed"));
      this.flag = false;
      }
    },
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    // 查看数采器对应设备
    getDeviceList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // ...this.search,
        pn:this.deviceInfo.pn,
        devtype: 2304,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize
      };
      this.loadingdevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceList = this.Fnreturndev(res);
          this.pagination.total = res.data.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.pagination.total = 0;
        }
        this.loadingdevice = false;
      });
    },
    // 点击进入设备(通知显隐)
    enterDevice(info) {
      // console.log("show=>singleBox(device)");
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn, //
        sn: info.sn, //
        deviceSn: info.deviceSn || info.sn,
        devaddr: info.devaddr, //
        devcode: info.devcode, //
        status: info.status, //
        devalias: info.devalias, //
        pid: info.pid, //
        focus: info.focus, //
        usr: info.usr, //
        uid: info.uid, //
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
      });
      // 通知显示设备信息页(隐藏table)
      this.$emit('noticeSingleBox', true);
    },
    // 点击进入设备
    // enterDevice(info) {
    //   this.$store.commit("saveDeviceInfo", {
    //     pn: info.pn,
    //     sn: info.sn,
    //     devcode: info.devcode,
    //     devaddr: info.devaddr,
    //     devalias: info.devalias
    //   });
    // },
    // 点击进入设备(管)
    // enterDevice(info) {
    //   if (!info.uid) {
    //     this.$message.error(this.$t(`device.noAuth`));
    //     return;
    //   }
    //   this.$request
    //     .get("applyBrowsePermission", { uid: info.uid })
    //     .then(res => {
    //       if (res.err === 0) {
    //         // console.log('管理员进入设备', res.dat)
    //         let routeUrl = this.$router.resolve({
    //           path: "/general/home",
    //           query: {
    //             secret: res.dat.secret,
    //             token: res.dat.token,
    //             role: res.dat.role,
    //             pprAuth: res.dat.pprAuth,
    //             devcode: info.devcode,
    //             pn: info.pn,
    //             devaddr: info.devaddr,
    //             sn: info.sn
    //           }
    //         });
    //         window.open(routeUrl.href, "_blank");
    //       } else {
    //         this.$message.error(this.$t(`errCode.${res.err}`));
    //       }
    //     });
    // },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.devicebelonglist {
  .instructieClass{
    display: flex;
    max-width: 300px;
  }
  display: flex;
  flex: 1;
  flex-direction: column;
  // margin: 20px;
  overflow: auto;
  // background-color: rgb(34, 45, 53);
  height: 548px;
  // 统一按钮
  .elbtn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    line-height:normal
  }
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }
  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }
  // #操作结果提示#
  // 设备调试返回值
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }
  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }
  // 控制弹框
  .control {
    .tableBackgruond{
      background-color: #222d35
    }
    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 16px;
        }

        padding: 5px 12px;
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 1);
      }
    }

    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: @primaryTextColor;
      }
    }

    /deep/.el-input .el-input__inner {
      border: none;
    }

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: #ffffff;
      padding: 0px 10px;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
      border: none;
    }

    // /deep/.el-button,
    // /deep/.el-button:focus,
    // /deep/.el-button:hover {
    // 	background: transparent;
    // 	border: none;
    // 	color: @primaryTextColor;
    // }
    // 表头
    /deep/.el-table th {
      border: none;
      box-shadow: 0px 1px rgba(255, 255, 255, 0.25) inset,
        0px -1px rgba(255, 255, 255, 0.25) inset;
    }

    /deep/.el-table--border,
    /deep/.el-table--group {
      border: none;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    // 间距
    /deep/ .el-table__body {
      border-collapse: separate;
      border-spacing: 10px;
      table-layout: auto !important;
      background: rgba(34, 45, 53, 1);
    }
  }
  // 固件升级状态窗
  .upgradeNew {
  /deep/.el-radio__input.is-checked .el-radio__inner{
    background: #15C491;
    background-color: #15C491;
    border-color:#15C491;
  }
  /deep/.el-radio__input.is-checked+.el-radio__label{
    color: #15C491;
  }
  .processstatue,
  .processstatueEquipment {
    font-size: 16px;
    color: #16D09A;
  }
  .processstatue,
  .processstatueEquipment1 {
    font-size: 16px;
    color: #ff3e3e;
  }

  /deep/.el-progress__text {
    color: #ffffff;
  }

  .progerssComplete,
  .progerssCompleteEquipment {
    background: transparent;
  }

  // 升级完成显示已完成的设备列表
  .progerssCompleteEquipment {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0px;
    align-items: flex-start;

    .progressName {
      margin-left: 0px;
    }
  }
      // 遮罩
      /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
}
  // 重定向
  .redirect {
    color: rgb(51, 255, 182);
    cursor: pointer;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 28px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    .showresultbox {
    display: flex;
    flex-direction: column;
    align-items: center;

    // 图标
    .showsuccess {
      border: 3px solid rgba(37, 255, 174, 1);
      background-color: rgba(19, 195, 156, 1);
      background-image: url(../../../../assets/img/general/Icon_Finished.png);
      background-size: 70px 70px;
    }

    .showfail {
      border: 3px solid rgba(246, 189, 189, 1);
      background: rgba(251, 75, 75, 1);
      background-image: url(../../../../assets/img/general/Icon_Failed.png);
      background-size: 120px 120px;
    }

    .showbase {
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
    }

    // 提示
    .showresulttext {
      font-weight: bold;
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 30px;
      color: rgba(255, 255, 255, 1);
    }

    // 操作
    .showoperate {
      text-align: center;
    }

    .showresultbtn {
      width: 102px;
      height: 30px;
      margin-top: 10px;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
    }
  }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    // .search {}
    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      // /deep/.el-table tr {
      //   border-right: 1px solid rgba(198, 209, 221, 0.5);
      // }
      /deep/.el-table--border,
      /deep/.el-table--group {
        border: none;
        // border: 1px solid rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
        border-right: 1px solid rgb(180, 184, 193);
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: 1px solid rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      /deep/.el-table__body-wrapper {
        background: rgb(34, 45, 53);
      }

      /deep/.el-table--scrollable-x .el-table__body-wrapper {
        background: rgb(34, 45, 53);
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }
    }

    .tablebottom {
      // text-align:center;
      display: flex;
      justify-content: space-between;
      // margin-bottom: 10px;
      // border-top: 1px solid rgba(198, 209, 221, 0.5);
      border: none;

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        // align-self: flex-start;
        padding: 0;
        margin: 0;
        // margin-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
          border: none;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
        }

        /deep/.el-pager li:not(.disabled).active {
          background: #15C491;
          color: #ffffff;
        }

        /deep/.el-pager li:not(.disabled):not(.active):hover {
          color: #15C491;
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // /deep/.el-pagination button:disabled {
        //   background-color: #2B3842;
        //   color: #7B8395;
        // }
        // /deep/.el-pagination button, 
        // /deep/.el-pagination span:not([class*=suffix]) {
        //   height: 48px;
        //   line-height: 48px;
        // }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        color: #15C491;
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>